var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"11"}},[_c('p',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.header))]),_c('h2',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.action))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }